import axios from 'axios';
import config from '../config';

/**
 * Axios instance configured for the ORB API
 * Includes automatic auth header injection and error handling
 */
const apiClient = axios.create({
  baseURL: config.api_base_url,
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json'
  }
});

/**
 * Request interceptor to add authentication token
 */
apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('auth_token');
    if (token) {
      config.headers['x-orb-auth'] = token;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

/**
 * Response interceptor to handle common errors
 */
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      window.location.replace('/');
    }
    return Promise.reject(error);
  }
);

export default apiClient;

